import routes from './router'
import Router from 'vue-router'
import {get} from './api/index'
import {formatRoutes,loadView} from './utils/index'
const createRouter = () => new Router({
  routes,
})
let isMenus = false;
const router = createRouter();
router.beforeEach(async(to, from, next) => {
  let token = sessionStorage.getItem('token');
  if(!isMenus&&token){
    isMenus =true;
    var {data} = await get('index/getMenuList',{}, false);
    sessionStorage.setItem('menu', JSON.stringify(data));
    var list=formatRoutes(data)
    var obj={
      path: '/',
      name: '',
      component:loadView('Home'),
      children: list,
    }
    router.addRoute(obj);
    next({
      ...to,
      replace:true,
    })
  }else {
    var white_list = ['/template','/login','/agreement'];
    if (!token && white_list.indexOf(to.path) == -1) {
      next({
        path: '/login'
      })
    } else if(to.path == '/'){
      next({
        path: '/index'
      })
    }else{
      next();
    }
  }
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router


// WEBPACK FOOTER //
// ./src/permission.js